module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "key-container"
  }, [_c('div', {
    staticClass: "keyboard",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleKeyPress($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "key-row"
  }, [_c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": "7"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": "8"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": "9"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "key-row"
  }, [_c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": "4"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": "5"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": "6"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "key-row"
  }, [_c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": "1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": "2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": "3"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "key-row"
  }, [_c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": "."
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": "0"
    }
  }, [_vm._v("0")])]), _vm._v(" "), _c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell key-delete",
    attrs: {
      "data-num": "D"
    }
  }, [_vm._v("删除")])]), _vm._v(" "), _c('div', {
    staticClass: "cell-box"
  }, [_c('div', {
    staticClass: "key-cell",
    attrs: {
      "data-num": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "key-right-clear"
  }, [_c('div', {
    staticClass: "key-clear",
    attrs: {
      "data-num": "C"
    }
  }, [_vm._v("清空")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "key-right-confirm"
  }, [_c('div', {
    staticClass: "key-confirm",
    attrs: {
      "data-num": "S"
    }
  }, [_vm._v("确认")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-168794f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NumKeypad.vue
// module id = 2232
// module chunks = 0